const hints = {
  fa: 'برچسب اختیاری است. می‌توانید این خدمت را بدون برچسب ذخیره کنید.',
  en: 'Tags are optional. You can save this service without tags.',
  ar: 'الوسوم اختيارية. يمكنك حفظ هذه الخدمة دون وسوم.',
}

export default locale => hints[locale] || hints.fa
